<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoReporte
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex>
                  <SelectProveedor
                    :model="itemActivo.Id_Proveedor"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarProveedor"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-radio-group
                    v-model="itemActivo.NombreCondicionVenta"
                    :mandatory="false"
                  >
                    <v-radio label="Contado" value="CONTADO"></v-radio>
                    <v-radio label="Cta.Cte." value="CTA.CTE."></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <FechaRango
                    :fechaDesde="itemActivo.FechaDesde"
                    :fechaHasta="itemActivo.FechaHasta"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarFecha"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import EncabezadoReporte from "@/components/EncabezadoReporte";
import PieCrud from "@/components/PieCrud";
import Mensaje from "@/components/Mensaje";
import SelectProveedor from "@/components/Compra/SelectProveedor";
import FechaRango from "@/components/FechaRango";
export default {
  name: "CompraListarPorProveedor",
  components: {
    EncabezadoReporte,
    PieCrud,
    Mensaje,
    SelectProveedor,
    FechaRango
  },
  data() {
    return {
      titulo: "Ficha del Proveedor",
      itemVacio: {
        Id_Proveedor: 0,
        NombreRazonSocialCuit: "",
        NombreCondicionVenta: "CTA.CTE.",
        FechaDesde: "",
        FechaHasta: ""
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido"
      },
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: ""
    };
  },
  created() {
    this.inicializar();
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Imprimir":
        case "ExportarXls":
          if (this.$refs.form.validate()) this.imprimir();
          break;
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.$refs.form.resetValidation();
          this.inicializar();
          eventBus.$emit("inicializarSelectProveedor");
          break;
      }
    },
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
      setTimeout(() => {
        eventBus.$emit("setearFocoSelectProveedor");
      }, 100);
    },
    seleccionarProveedor(item) {
      this.itemActivo.Id_Proveedor = item.Id_Proveedor;
      this.itemActivo.NombreRazonSocialCuit = item.NombreRazonSocialCuit;
    },
    seleccionarFecha(item) {
      this.itemActivo.FechaDesde = item.FechaDesde;
      this.itemActivo.FechaHasta = item.FechaHasta;
    },
    imprimir() {
      this.loading = true;
      HttpHelper.getBlob("Compra/ListarPorProveedor", {
        accion: this.accion,
        id_Proveedor: this.itemActivo.Id_Proveedor,
        nombreProveedor: this.itemActivo.NombreRazonSocialCuit,
        nombreCondicionVenta: this.itemActivo.NombreCondicionVenta,
        fechaDesde: this.itemActivo.FechaDesde,
        fechaHasta: this.itemActivo.FechaHasta
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1]
            .trim();
          link.setAttribute("download", "Reporte_" + fileName);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response == undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
